import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons/faWindowClose";
import FetchAllAssetsAsinWiseService from "../../../../../Service/OPSServices/AmazonProductListing/FetchAllAssetsAsinWiseService";
import { connect } from 'react-redux';
import CustomModal from "../../../../Components/Modals/CustomModal";
function ProductListingImages(props) {
  const [galleryImages, setGalleryImages] = useState(props.listingData && props.listingData.formData && props.listingData.formData.galleryImages);
  const [galleryImg, setGalleryImg] = useState()
  const [imagePopUpOPen, setImagePopUpOPen] = useState(false)
  const [selectedImages, setSelectedImages] = useState([]);


  useEffect(() => {
    let data = {
      asin: props.listingData.asin
    }
    FetchAllAssetsAsinWiseService(props.token, data).then((res) => {
      if (res) {
        console.log(res)
        setGalleryImg(res.fileList)
      }
    })
  }, [])



  const handleGalleryImages = () => {
    setImagePopUpOPen(true)
    setGalleryImages(props.listingData && props.listingData.formData && props.listingData.formData.galleryImages)
  };
  const handleReplaceImages = (img) => {
    setSelectedImages((prev) => {
      if (prev.includes(img.fileId)) {
        return prev.filter(id => id !== img.fileId)
      } else {
        return [...prev, img.fileId]
      }
    })
  }
  const handleSubmitFile = () => {
    const selectedFilePaths = galleryImg
      .filter(img => selectedImages.includes(img.fileId))
      .map(img => img.filePath)

    setGalleryImages(selectedFilePaths)
    setImagePopUpOPen(false)
  }

  const handleUpdateFiles = () => {
    const selectedFilePaths = galleryImg
      .filter(img => selectedImages.includes(img.fileId))
      .map(img => img.filePath)

    // setGalleryImages(selectedFilePaths) 
    setGalleryImages((prev) => [...prev, ...selectedFilePaths])
    setImagePopUpOPen(false)
  }
  const handleNext = () => {
    props.setListingData(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        mainImage: galleryImages[0] || "",
        galleryImages: galleryImages
      }
    }));
  
    props.nextStep();
  };
  return (
    <>
      <Row>
        <Col md={12} className="mt-2  mb-2 ml-2">
          <div className="d-flex justify-containt-between">
            <h4>Step 5 : Product Images</h4>
            <Button
              className="ml-auto"
              onClick={() => handleGalleryImages()} >
              Upload Images
            </Button>
          </div>
        </Col>

        <Col md={12} className="ml-1 mr-4">
          <Card className="p-4">

            <Row className="mb-4">
              <Col md={4} className="amazon-listing-labels">
                Main Image :
              </Col>

              <Col>
                <img
                  src="https://m.media-amazon.com/images/I/61EmUcXXkHL.jpg"
                  alt="product"
                  style={{ width: "200px", height: "auto" }}
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4} className="amazon-listing-labels">
                Gallery Images :
              </Col>

              <Col>
                {galleryImages && galleryImages.map((img) => (
                  <img
                    src={img}
                    className="p-1 m-1"
                    alt="product"
                    style={{ width: "200px", height: "auto" }}
                  />
                ))}

              </Col>
            </Row>


          </Card>
        </Col>

        <Col md={12} className="mt-3 d-flex justify-content-between">
          <button className="btn btn-light" onClick={props.prevStep}>
            ← Back
          </button>
          <button className="btn btn-primary" onClick={handleNext}>
            Next →
          </button>
        </Col>
      </Row>
      <CustomModal
        isOpen={imagePopUpOPen}
        toggle={() => { setImagePopUpOPen(false); setGalleryImages(props.listingData && props.listingData.formData && props.listingData.formData.galleryImages) }}
        size={"xl"}
        header={''}
        className="curve-popup "
      >
         <div className='d-flex justify-content-end mb-2' >
            <Button 
            className='mr-2'
            onClick={() => handleSubmitFile()}>
              Replace
            </Button>
            <Button onClick={() => handleUpdateFiles()}>
              Add imgs
            </Button>
          </div>
        <Row>
         
          {galleryImg && galleryImg.map((asset) => (
            <Col sm={4} md={3} key={asset.fileId}>
              <Card>
                <div onClick={() => handleReplaceImages(asset)}>
                  <img
                    src={asset.filePath}
                    alt="not found"
                    width="100%"
                    height="100%"
                  />

                  <p className="text-center mt-2" title={asset.fileName} style={{ fontSize: "13px" }}>
                    {asset.fileName.length > 30
                      ? `${asset.fileName.substring(0, 30)}...`
                      : asset.fileName}
                  </p>
                </div>

                <div className="text-center mt-2">
                  <input
                    type="checkbox"
                    checked={selectedImages.includes(asset.fileId)}
                    onChange={(e) => {
                      e.stopPropagation()
                      handleReplaceImages(asset)
                    }}
                  />
                </div>
              </Card>
            </Col>
          ))}
        </Row>

      </CustomModal>
    </>
  );
}

const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    globalPermissions: state.loggedUser.globalPermissions,
    UserPermission: state.accountOverview.store.StoreUserPermission,
    enableClosedSidebar: state.theme.enableClosedSidebar,
  }
}

export default connect(mapStateToProps)(ProductListingImages);